module.exports = __webpack_public_path__ + "img/北三指挥系统.9ef25af3.png";